import api from './api';

const API_PREFIX = '/scriptExecution';

const getScriptExecutionAll = ({ limit, page, customerEnvId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/all${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getScriptExecutionDeviceAll = ({ limit, page, customerEnvId, query, deviceId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${deviceId}/all${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getScriptExecutionDetails = ({ customerEnvId, scriptExecutionId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${scriptExecutionId}`);

const getScriptExecutionAffectedDevices = ({ limit, page, customerEnvId, scriptExecutionId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${scriptExecutionId}/affectedDevices${query}`,
    {
      params: {
        ...(limit ? { Limit: limit } : {}),
        ...(page ? { Page: page } : {}),
      },
    });

const ScriptExecutionService = {
  getScriptExecutionAll,
  getScriptExecutionDeviceAll,
  getScriptExecutionDetails,
  getScriptExecutionAffectedDevices,
};

export default ScriptExecutionService;
